var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicCloudDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "publicCloudIcon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .tbv3-pclouddefault-cls1 {\n            fill: #2e368f;\n            }\n\n            .tbv3-pclouddefault-cls2 {\n            fill: #2e3192;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 190,
    rx: 28,
    y: 0,
    x: 0,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0 -35)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tbv3-pclouddefault-cls1",
    d: "M104.43,69.7c18.41,0,35.2,10.89,42.77,27.75l5.4,12.03,10.87-7.46c3.07-2.11,6.66-3.22,10.38-3.22,9.94,0,17.98,7.79,18.3,17.75l.32,9.77,9.74,.83c17.7,1.51,30.51,19.43,30.51,30.77v3.82c0,12.56-15.19,27.16-34.78,27.16H63.09c-19.59,0-34.78-14.6-34.78-27.16v-3.82c0-10.36,9.55-25.65,21.4-29.08l8.2-2.37-.26-8.53c-.01-.39-.04-.77-.06-1.15,0-.08-.01-.17-.02-.26,.04-25.82,21.05-46.81,46.87-46.81m0-11c-31.96,0-57.87,25.9-57.87,57.88,0,.57,.07,1.12,.09,1.68-17.15,4.97-29.34,25.04-29.34,39.65v3.82c0,18.97,20.51,38.16,45.78,38.16H197.92c25.28,0,45.78-19.19,45.78-38.16v-3.82c0-17.64-17.75-39.78-40.57-41.73-.51-15.77-13.42-28.39-29.29-28.39-6.16,0-11.88,1.91-16.6,5.16-9.05-20.17-29.26-34.25-52.8-34.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tbv3-pclouddefault-cls2",
    d: "M79.4,131.89c7.42,0,10.5,2.62,10.5,7.87s-3.23,7.84-10.3,7.84h-2.4v7.33h-6.66v-23.04h8.86Zm-2.21,4.51v6.72h2.43c2.18,0,3.52-1.18,3.52-3.36,0-2.3-1.34-3.36-3.68-3.36h-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tbv3-pclouddefault-cls2",
    d: "M99.18,131.89v15.49c0,2.18,1.31,3.39,3.55,3.39s3.71-1.22,3.71-3.39v-15.49h6.5v15.1c0,5.18-3.65,8.42-10.24,8.42s-10.21-3.26-10.21-8.42v-15.1h6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tbv3-pclouddefault-cls2",
    d: "M124.84,131.89c7.04,0,9.89,2.02,9.89,6.08,0,2.21-1.66,4.03-3.87,4.7,2.82,.54,4.77,2.66,4.77,5.54,0,4.26-2.82,6.72-10.08,6.72h-9.12v-23.04h8.42Zm-1.73,4.35v4.64h2.3c1.7,0,2.62-.83,2.62-2.4,0-1.41-1.06-2.24-2.72-2.24h-2.21Zm0,8.7v5.63h2.62c2.18,0,3.17-.86,3.17-2.72s-1.18-2.91-3.01-2.91h-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tbv3-pclouddefault-cls2",
    d: "M145.1,131.89v18.21h10.97v4.83h-17.66v-23.04h6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tbv3-pclouddefault-cls2",
    d: "M165.22,131.89v23.04h-6.69v-23.04h6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tbv3-pclouddefault-cls2",
    d: "M183.66,139.86c-.58-2.78-2.11-3.87-4.03-3.87-2.66,0-4.58,2.08-4.58,7.36s1.98,7.49,4.42,7.49,4-1.47,4.26-4.74h6.75c-.8,6.3-4.74,9.31-11.1,9.31s-11.23-4.16-11.23-12.06,4.38-11.94,11.49-11.94c5.63,0,9.79,2.98,10.69,8.45h-6.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicCloudDefault);
export default __webpack_public_path__ + "static/media/PublicCloudDefault.327cc16da5b359267c3409470c841456.svg";
export { ForwardRef as ReactComponent };